var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        _vm._b(
          {
            class: [
              "codeblock-container",
              { "one-line": _vm.centerCodeblockActions },
            ],
            on: { click: _vm.shadowCopy },
          },
          "div",
          _vm.shadowCopyAttrs,
          false
        ),
        [
          _vm.helpWithNpmKit
            ? _c(
                "div",
                {
                  staticClass:
                    "margin-md margin-horizontal-2xl margin-bottom-0",
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "row align-middle align-between with-border-radius padding-vertical-sm",
                      staticStyle: {
                        "border-radius": "var(--codeblock-border-radius)",
                        "background-color": "var(--gray-700)",
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "column-8" },
                        [
                          _c("font-awesome-icon", {
                            attrs: { icon: _vm.$v7.solid.faCircleInfo },
                          }),
                          _vm._v("\n        Get a\n        "),
                          _c(
                            "site-link",
                            {
                              staticClass: "inverted",
                              staticStyle: {
                                "background-color": "var(--gray-700)",
                              },
                              attrs: { to: { name: "plans" } },
                            },
                            [_vm._v("Pro Plan")]
                          ),
                          _vm._v(", replace "),
                          _c("span", [_vm._v("KIT_CODE")]),
                          _vm._v(" with a Kit token\n      "),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c(
                            "site-link",
                            {
                              staticClass:
                                "button inverted flat compact margin-bottom-0",
                              staticStyle: { "--link-color": "var(--white)" },
                              attrs: { to: { name: "kits" } },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: _vm.$v7.regular.faBackpack },
                              }),
                              _vm._v("\n          Your Kits"),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.codeHidden
            ? [
                _c(
                  "div",
                  { ref: "codeblock", attrs: { hidden: "" } },
                  [_vm._t("default")],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { class: ["codeblock", { "attached-top": _vm.attachedTop }] },
                  [
                    _c("pre", [
                      _c(
                        "code",
                        [
                          _c("wa-obfuscated-text", {
                            attrs: {
                              "icon-name": "faAsterisk",
                              length: 21,
                              "custom-style": { color: "var(--code-color)" },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                ),
              ]
            : [
                _vm.addHighlighting == false
                  ? _c(
                      "div",
                      {
                        ref: "codeblock",
                        class: [
                          "codeblock",
                          { "attached-top": _vm.attachedTop },
                        ],
                      },
                      [_vm._t("default")],
                      2
                    )
                  : _c(
                      "wa-code-highlight",
                      {
                        ref: "codeblock",
                        class: [
                          "codeblock",
                          { "attached-top": _vm.attachedTop },
                        ],
                        attrs: {
                          lang: _vm.lang,
                          code: _vm.codeWithReplacements,
                        },
                      },
                      [_vm._t("default")],
                      2
                    ),
              ],
          _vm._v(" "),
          _vm._t("caption"),
          _vm._v(" "),
          _c(
            "div",
            {
              class: [
                "codeblock-actions",
                { "center-y": _vm.centerCodeblockActions },
              ],
            },
            [
              _vm.toggleCode
                ? _c(
                    "button",
                    {
                      staticClass: "action-button",
                      attrs: {
                        "data-balloon-pos": "up",
                        "aria-label": _vm.codeToggleText,
                      },
                      on: { click: _vm.toggleShowCode },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: _vm.$v7.solid[_vm.showIcon],
                          size: "lg",
                        },
                      }),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v(_vm._s(_vm.codeToggleText)),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.allowCopy
                ? _c(
                    "button",
                    {
                      staticClass: "action-button",
                      attrs: {
                        "aria-label": `${_vm.copyText}`,
                        "data-balloon-pos": "up",
                      },
                      on: { click: _vm.copy },
                    },
                    [
                      _c("font-awesome-icon", {
                        attrs: {
                          icon: _vm.$v7.solid[_vm.copyIcon],
                          size: "lg",
                        },
                      }),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v(_vm._s(_vm.copyText)),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ]
          ),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }